<header class="main-header">

  <!-- Logo -->
  <a class="logo">
    <!-- mini logo for sidebar mini 50x50 pixels -->
    <span class="logo-mini">
      <b>C</b>MS</span>
    <!-- logo for regular state and mobile devices -->
    <span class="logo-lg">
      <b>SmartSafe</b>CMS</span>
  </a>

  <!-- Header Navbar: style can be found in header.less -->
  <nav class="navbar navbar-static-top">
    <!-- Sidebar toggle button-->
    <a class="sidebar-toggle" data-toggle="push-menu" role="button">
      <span class="sr-only">Toggle navigation</span>
    </a>
    <!-- Navbar Right Menu -->
    <div class="navbar-custom-menu">
      <ul class="nav navbar-nav">
        <!-- Messages: style can be found in dropdown.less-->
        <li class="dropdown messages-menu">
          <a routerLink="/login" class="dropdown-toggle">
            <i class="fa fa-sign-out" aria-hidden="true"></i>
            Logout
          </a>
        </li>
      </ul>
    </div>
  </nav>
</header>


// WEBPACK FOOTER //
// /build/client-cms/src/app/layout/header/header.component.html